module.exports = __webpack_public_path__ + "static/blog-img5-a1121781a0417e0c2f1432ba1238655d.jpg";